import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { User, UserHierarchyNode, AuthorizationLevelInfo } from '../../model';
import UserHierarchyNodeComponent from './UserHierarchyNodeComponent';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(1),
    paddingTop: theme.spacing(0.5),
  },
}));

interface HierarchyTreeViewProps {
  hierarchyTree: UserHierarchyNode[];
  expandedNodes: Set<number>;
  selectedUser: User | undefined;
  authorizationLevels: AuthorizationLevelInfo[];
  allUsers: User[];
  onUserSelect: (user: User) => void;
  onNodeToggle: (userId: number) => void;
  onUpdateReporting: (userId: number, newManagerId: number | null) => void;
  getAuthorizationLevelColor: (level: number) => string;
}

const HierarchyTreeView: React.FC<HierarchyTreeViewProps> = ({
  hierarchyTree,
  expandedNodes,
  selectedUser,
  authorizationLevels,
  allUsers,
  onUserSelect,
  onNodeToggle,
  onUpdateReporting,
  getAuthorizationLevelColor,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {hierarchyTree.map((node) => (
        <UserHierarchyNodeComponent
          key={node.user.id}
          node={node}
          level={0}
          isExpanded={expandedNodes.has(node.user.id)}
          isSelected={selectedUser?.id === node.user.id}
          expandedNodes={expandedNodes}
          selectedUserId={selectedUser?.id}
          authorizationLevels={authorizationLevels}
          allUsers={allUsers}
          onUserSelect={onUserSelect}
          onNodeToggle={onNodeToggle}
          onUpdateReporting={onUpdateReporting}
          getAuthorizationLevelColor={getAuthorizationLevelColor}
        />
      ))}
    </div>
  );
};

export default HierarchyTreeView;
